import { useContext, useEffect, useMemo, useState } from 'react';
import { showCustomDialog } from '../../scripts/learnosityScripts.js';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import * as Storage from '../common/Storage.js';
import useSessionStorage from '../../hooks/useSessionStorage.js';
import CustomDialog from '../ui/feedback/CustomDialog.js';
import { waitToResume } from '../../scripts/less-secure/enforceLessSecure.js';
import { useTranslation } from 'react-i18next';

const ContinueDialog = ({ open, setOpen }) => {
  //name of session storage variable
  const { removeStorageItem } = useSessionStorage();
  const { learnosityItemApp } = useContext(AssessmentContext);
  const { t } = useTranslation();
  const DIALOG_TITLE = t('components.continueDialog.connectionRestored');
  const DIALOG_MESSAGE = t('components.continueDialog.prompt');
  const DIALOG_ACTIONS = useMemo(
    () => [
      {
        label: t('common.continue'),
        handle: () => {
          setOpen(false);
        },
      },
    ],
    [setOpen, t],
  );

  const [dialogDetails, setDialogDetails] = useState();

  useEffect(() => {
    if (open) {
      removeStorageItem(Storage.STORAGE_AUTO_EXIT_SECONDS);
      const __waitToResume = waitToResume();
      const dialogProps = {
        title: DIALOG_TITLE,
        message: __waitToResume
          ? DIALOG_MESSAGE
          : t('components.continueDialog.waitForAdmin'),
        ...(__waitToResume ? { actions: DIALOG_ACTIONS } : {}),
      };
      setDialogDetails(dialogProps);
      showCustomDialog(
        learnosityItemApp,
        {
          header: dialogProps.title,
          body: dialogProps.message,
        },
        true,
      );
    }
  }, [open, learnosityItemApp, removeStorageItem, DIALOG_ACTIONS, DIALOG_MESSAGE, DIALOG_TITLE, t]);

  return (
    <>
      <CustomDialog open={open} dialogProps={dialogDetails} />
    </>
  );
};

export default ContinueDialog;
